import React, { Children, PropsWithChildren } from "react";
import Heading from "atoms/typography/heading";
import { HeadingPriority } from "atoms/constants/heading-priority";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { CollectionUtils } from "utilities/collection-utils";
import { t } from "utilities/localization-utils";
import Paragraph from "atoms/typography/paragraph";
import useNetworkInformation from "utilities/contexts/network-information/use-network-information";
import OfflineFeatureDisabledInfo from "organisms/offline-feature-disabled-info/offline-feature-disabled-info";

interface RecentItemsListProps extends PropsWithChildren {
    resource: string;
    onViewAllClick: () => void;
}

const CSS_BASE_CLASS = "c-recent-items-list";

const RecentItemsList = (props: RecentItemsListProps) => {
    const { children, onViewAllClick, resource } = props;
    const { isOnline } = useNetworkInformation();
    return (
        <section className={CSS_BASE_CLASS}>
            <header className={`${CSS_BASE_CLASS}__header`}>
                <Heading
                    cssClassName={`${CSS_BASE_CLASS}__heading`}
                    priority={HeadingPriority.Four}>
                    {t("recentResources", { resource })}
                </Heading>
                {isOnline && (
                    <Button
                        onClick={onViewAllClick}
                        style={ButtonStyles.Secondary}
                        size={ButtonSizes.Small}>
                        {t("viewAllResources", { resource })}
                    </Button>
                )}
            </header>
            {isOnline &&
                (CollectionUtils.isEmpty(Children.toArray(children)) ? (
                    <div className={`${CSS_BASE_CLASS}__noResultsWrapper`}>
                        <Paragraph
                            cssClassName={`${CSS_BASE_CLASS}__noResults`}>
                            {t("noResourceAdded", {
                                resource: resource,
                            })}
                        </Paragraph>
                    </div>
                ) : (
                    <ul className={`${CSS_BASE_CLASS}__list`}>
                        {Children.map(children, (child) => (
                            <li className={`${CSS_BASE_CLASS}__listItem`}>
                                {child}
                            </li>
                        ))}
                    </ul>
                ))}
            {!isOnline && <OfflineFeatureDisabledInfo resource={resource} />}
        </section>
    );
};

export default RecentItemsList;
